import React from "react";
import "./whoweare.css";
import { Link } from "react-router-dom";
import Fit from "../../assets/PandM.jpg";
import Mission from "../../assets/church.jpg";

const Whoweare = () => {
  return (
    <div className="whoweare">
      <div className="whoweare__intro">
        <div className="whoweare__contentContainer">
          <h4>Who we are</h4>
          <p>
            Golden Girls on the Move wants to create a society where women are
            encouraged to be active in sports and to support them in their
            physical, mental, spiritual and social needs. Our target is not only
            limited to encouraging women aged 50+ to be physically active but also
            to support young sportswomen across all sporting activities
          </p>
          <div className="whoweare__introBtnContainer">
            <Link to="/about">
              <button className="whoweare__introBtn">
                Read More About Us
                <span class="blob-btn__inner">
                  <span class="blob-btn__blobs">
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                  </span>
                </span>
              </button>
              <br />
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0" style={{ position: "absolute" }}>
                <defs>
                  <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10"></feGaussianBlur>
                    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7" result="goo"></feColorMatrix>
                    <feBlend in2="goo" in="SourceGraphic" result="mix"></feBlend>
                  </filter>
                </defs>
              </svg>
            </Link>
          </div>
        </div>
      </div>
      <div className="whoweare__visionContainer">
        <h4 className="whoweare__visionH4">Our Vision</h4>
        <div className="whoweare__visionInnerDiv">
          <div className="whoweare__vision">
            <div className="whoweare__visionImgDiv">
              <img
                src={Mission}
                alt="whoweare__visionImg"
                className="whoweare__visionImg"
              />
            </div>
            <div className="whoweare__visionTxt">
              <h4>Our Vision</h4>
              <span>
                <br />
                <i>
                  <b>"A nation with vibrant sportswomen at all ages."</b>
                </i>
              </span>
              <p>
                Here at GG-M we strive to support women of all ages who participate
                or are planning to get involve in any sport.
              </p>
              <a className="whoweare__visionBtn whoweare__visionBtn-white whoweare__visionBtn-animated" href="/about">Read More</a>
            </div>
          </div>
        </div>
      </div>
      <div className="whoweare__missionDiv">
        <div className="whoweare__mission">
          <div className="whoweare__missionTxt">
            <h4>Our Mission</h4>
            <span>
              <i>
                <b>
                  "To nurture the active participation of women 50+ in sports
                  while supporting young sportswomen to thrive in Kenya."
                </b>
              </i>
            </span>
            <p>
              Our registered members are women aged 50 or older seeking to be
              active in sports as well as supporting other sportswomen across all
              ages by supporting various sporting organizations and
              running campaigns addressing challenges facing women
            </p>
            <a className="whoweare__missionBtn whoweare__missionBtn-white whoweare__missionBtn-animated" href="/about">Read More</a>
          </div>
          <div className="whoweare__missionImgDiv">
            <img
              src={Fit}
              alt="whoweare__missionImg"
              className="whoweare__missionImg"
            />
          </div>
          <a className="mob_whoweare__missionBtn mob_whoweare__missionBtn-white mob_whoweare__missionBtn-animated" href="/about">
            Read More
          </a>
        </div>
      </div>
      {/* Goals */}
      <div className="goals">
        <div className="ourGoals">
          <h4 className="ourGoalsHead">What we can achieve together</h4>
          <div className="goalsList">
            <div className="ourGoalsListTxt">
              <p>
                Golden Girls on the move is not just another Sports Club; we
                understand the change being physically active can bring to a
                woman's life. Together we can:
              </p>
            </div>
            <div className="objectiveBars">
              <div className="objectiveBar">
                {/* <i class="fa-solid fa-user-group"></i> */}
                <i class="fa-solid fa-users"></i>
                Organize events/forums for members
              </div>
              <div className="objectiveBar"><i class="fa-solid fa-hand-holding-heart"></i>Nurture young sportswomen</div>
              <div className="objectiveBar">
                <i class="fa-solid fa-medal"></i>
                Organize regional and national sports events for women
              </div>
              <div className="objectiveBar">
                <i class="fa-solid fa-briefcase"></i>
                Advocate for women in sports at all levels
              </div>
              <div className="objectiveBar">
                <i class="fa-solid fa-handshake-angle"></i>
                Support counties to develop initiatives for women 50+ years
              </div>
            </div>
            <div className="goalsBtnDiv">
              <button className="goalsBtn">
                <a href="/about">Learn More</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whoweare;
